import React from 'react'

function Hero() {
    return (
        <> 
            <div className='container'>
                <div className='row text-center mt-5'>
                    <img src='media/Hero.png' alt='logo' className='mb-3'/>
                    <h1 className='mt-5'>Invest in everything</h1>
                    <p>Online platform to invest in stocks, derivatives,mutual funds and others</p>
                    <button className='p-3 btn btn-primary' style={{width: "30%" ,margin: "0 auto"}}>Signup Now</button>
                </div>

            </div>
        </>
    );
}

export default Hero;